// eslint-disable-next-line import/prefer-default-export
export const isHappyFlowForUSA = (inventory: any = {}, openingSource = "") =>
  (inventory?.location?.country?.short_name === "US" &&
    (openingSource === "clicked_book_enquire_now_property" ||
      openingSource === "search_inventory_enquire")) ||
  false;
